module.exports = __webpack_public_path__ + "img/Talk Graphic 5.10c1b6d1.jpg";